
export class ComponentType {
  _KEY!: string;
  name = '';
  tags!: string;
  file_key!: string;
  private html!: string;
  private css!: string;
  private _META!: {
    created_time: string;
    updated_time: string;
  };

  constructor(template?: Partial<ComponentType>) {
    if (template) {
      Object.assign(this, template);
    }
  }
}
